import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@app/shared/services';

@Component({
  selector: 'ld-header-links',
  templateUrl: './header-links.template.html',
  styleUrls: [ './header-links.style.scss' ]
})
export class HeaderLinksComponent {
  @Input() isOnPersonalPortal = false;

  constructor(private router: Router, private sessionService: SessionService) {}

  public navigateToHome(e: MouseEvent): void {
    this.sessionService.navigateToUla('dashboard').then(
      redirected => {
        if (!redirected) {
          this.router.navigate(['dashboard']);
        }
      }
    );
  }
}
